import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = { class: "sec-main resultP-main bg-gray" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "關鍵字搜尋結果", -1)
const _hoisted_9 = { class: "row head-row mb-4" }
const _hoisted_10 = { class: "col-11 col-sm-10 mx-auto" }
const _hoisted_11 = { class: "fcss" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 text-primary mb-md-4 mb-3" }, "關鍵字搜尋結果", -1)
const _hoisted_13 = { class: "h3" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-10 mx-auto" }
const _hoisted_16 = { class: "lists-group" }
const _hoisted_17 = { class: "fcss mb-2" }
const _hoisted_18 = { class: "h4" }
const _hoisted_19 = { class: "h3" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "link-anchor"
  }, "詳細內容")
], -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pagination_component = _resolveComponent("pagination-component")!
  const _directive_title = _resolveDirective("title")!

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("h2", _hoisted_13, "搜尋關鍵字：" + _toDisplayString(_ctx.keyword) + "，共查詢到 " + _toDisplayString(_ctx.page?.totalElements) + " 筆", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page?.content, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "list-card mb-md-3 mb-2"
                }, [
                  _createVNode(_component_router_link, {
                    to: {name: item.key + '-detail', params: { id: item.id }},
                    title: "資源搜尋",
                    class: "foo: false"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, "資源搜尋 > " + _toDisplayString(_ctx.nameMap[item.key]), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(item.title), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "h5 w-md-85 multiline-ellipsis editor-html",
                        innerHTML: _ctx.sanitizeHtml(item.description)
                      }, null, 8, _hoisted_20),
                      _hoisted_21
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_pagination_component, {
              class: "pagination-component",
              totalPages: _ctx.page.totalPages,
              onOnClick: _ctx.changePage
            }, null, 8, ["totalPages", "onOnClick"])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_title, '關鍵字搜尋']
  ])
}